var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "navbar has-shadow"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('div', {
    staticClass: "navbar-burger burger",
    class: {
      'is-active': _vm.isActive
    },
    attrs: {
      "data-target": "mainMenu"
    },
    on: {
      "click": _vm.toggleBurger
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu",
    class: {
      'is-active': _vm.isActive
    },
    attrs: {
      "id": "mainMenu"
    }
  }, [_c('div', {
    staticClass: "navbar-end"
  }, [_c('router-link', {
    staticClass: "navbar-item r-item",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("STATS50@TCD")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item r-item",
    attrs: {
      "to": "isa"
    }
  }, [_vm._v("ISA short course")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item r-item",
    attrs: {
      "to": "gallery"
    }
  }, [_vm._v("Gallery")])], 1)])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _vm._m(0)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer is-primary"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Contacts: "), _c('a', {
    attrs: {
      "href": "mailto:arwhite@tcd.ie"
    }
  }, [_vm._v("Arthur White")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "mailto:wyseja@tcd.ie"
    }
  }, [_vm._v("Jason Wyse")])])]), _vm._v(" "), _c('div', {
    staticClass: "column copyr has-text-centered"
  }, [_c('p', [_vm._v("\n            copyright @2017 "), _c('a', {
    attrs: {
      "href": "http://www.bernardonipoti.com/",
      "target": "_blank"
    }
  }, [_vm._v("Bernardo Nipoti")])]), _vm._v(" "), _c('p', [_vm._v("\n            developed by "), _c('a', {
    attrs: {
      "href": "http://sanvisimo.it",
      "target": "_blank"
    }
  }, [_vm._v("sanvisimo")])])]), _vm._v(" "), _c('div', {
    staticClass: "column has-text-right"
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": "https://www.tcd.ie/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/trinity-common-use-white.png"),
      "alt": "TCD"
    }
  })])])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ef5a1e7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1Lxr
// module chunks = 0